<template>
  <v-container class="main" fluid>
    <SnackBarQueue v-model="messages"></SnackBarQueue>
    <v-card outlined flat class="pa-10">
      <h2 style="display: inline">Edit Validations</h2>
      <RefreshSpaces style="float:right"></RefreshSpaces>
      <v-divider class="horizontal-divider" /><br />
      <v-alert color="indigo" dark>
        <v-icon>mdi-information</v-icon>
        Insert or Update content type validations such as channels and canonical
      </v-alert>
      <v-row class="ma-2">
        <strong>Source Space</strong>
      </v-row>
      <v-row class="ma-2">
        <v-select style="width:50%" outlined :items="spaces" item-text="name" item-value="id" v-model="sourceSpace" />
        <v-select style="width:50%" :disabled="sourceSpace == null" outlined :items="sourceEnvs" item-text="name" value="id" v-model="sourceEnv" />
      </v-row>
      <v-row class="ma-2">
        <strong>Validations</strong>
      </v-row>
      <v-row class="ma-2" v-for="(validation, index) of validations" :key="index">
        <!-- Combobox for Adding/Removing Items -->
        <v-combobox
          v-model="validation.inValues"
          :loading="loading.validations"
          multiple
          chips
          clearable
          deletable-chips
          :label="validation.fieldId"
          hint="Press Enter to add"
        ></v-combobox>
      </v-row>
      <v-row class="ma-2">
        <strong>Content Types</strong>
        <v-tooltip top>
          <template v-slot:activator="{ on, attrs }">
            <v-icon color="grey" v-on="on" v-bind="attrs"> mdi-information </v-icon>
          </template>
          <span>Leave empty to update all content types</span>
        </v-tooltip>
      </v-row>
      <v-row class="ma-2">
        <ContentTypeSelection
          :spaceId="sourceSpace"
          :envId="sourceEnv"
          :multiple="true"
          :filterItems="(item) => item.fields.some((f) => this.validations.map((v) => v.fieldId).includes(f.id))"
          @changedSelection="(v) => (contentTypeIds = v)"
        ></ContentTypeSelection>
      </v-row>
      <v-row class="ma-2">
        <strong>Update Strategy</strong>
      </v-row>
      <v-row class="ma-2">
        <v-select style="width:50%" outlined :items="strategies" item-text="text" item-value="id" v-model="strategy" />
      </v-row>
      <v-btn class="ma-2 primary-button" dark @click="upsertValidations()" :loading="loading.upserting">Update Validations</v-btn>
    </v-card>
  </v-container>
</template>

<script>
import SnackBarQueue from "../helpers/SnackBarQueue.vue";
import RefreshSpaces from "./helpers/RefreshSpaces.vue";
import ContentTypeSelection from "./helpers/ContentTypeSelection.vue";
import { mapState } from "vuex";

export default {
  data() {
    return {
      messages: [],
      loading: {
        validations: false,
        upserting: false,
      },
      sourceSpace: null,
      sourceEnv: null,
      contentTypeIds: [],
      validations: [
        { fieldId: "channels", inValues: [] },
        { fieldId: "canonical", inValues: [] },
      ],
      strategies: [
        { text: "Add to existing validation items", id: "add" },
        { text: "Overwrite existing validation items", id: "overwrite" },
      ],
      strategy: "add",
    };
  },
  components: {
    SnackBarQueue,
    RefreshSpaces,
    ContentTypeSelection,
  },
  computed: {
    ...mapState({
      spaces: (state) => state.contentfulSpaces,
    }),
    sourceEnvs() {
      if (this.sourceSpace) {
        let space = this.spaces.find((space) => this.sourceSpace === space.id);
        if (space && space.environments) return space.environments;
      }
      return [];
    },
  },
  watch: {
    sourceSpace() {
      this.sourceEnv = null;
    },
    sourceEnv() {
      if (!this.sourceEnv) return;
      this.prefillValidations();
    },
  },

  methods: {
    upsertValidations() {
      if (!(this.sourceSpace && this.sourceEnv)) {
        return this.messages.push("Please select Source and Target Space first!");
      }

      if (this.validations.every((v) => v.inValues.length == 0)) return this.messages.push("Please add some validations!");

      this.loading.upserting = true;
      this.result = null;

      this.axios
        .post("/contentful/upsert-validations", {
          spaceId: this.sourceSpace,
          envId: this.sourceEnv,
          validations: this.validations,
          contentTypeIds: this.contentTypeIds,
          strategy: this.strategy,
        })
        .then((res) => {
          console.log(res);
          this.messages.push({ message: "Successfully updated content type validations!", color: "success" });
        })
        .catch((err) => {
          clearInterval(this.pollJob);
          this.messages.push({
            message: `Failed listing entries! ${err.response ? err.response.data.message : err.message}`,
            color: "error",
          });
          console.error(err);
        })
        .finally(() => (this.loading.upserting = false));
    },
    async prefillValidations() {
      this.loading.validations = true;
      const res = await this.axios.get(`/contentful/contentModel?spaceId=${this.sourceSpace}&environmentId=${this.sourceEnv}`);
      if (res && res.data && res.data.contentModel) {
        for (const { fieldId, inValues } of this.validations) {
          inValues.splice(0, inValues.length); // Clear existing values
          const prefillVals = new Set();
          for (const contentType of res.data.contentModel.items) {
            const field = contentType.fields.find((f) => f.id === fieldId);
            if (!field) continue;
            const vals = field.items && field.items.validations ? field.items.validations : field.validations;
            if (!vals) continue;
            const val = vals.find((v) => Array.isArray(v.in));
            if (val && Array.isArray(val.in)) val.in.forEach((v) => prefillVals.add(v));
          }
          inValues.push(...Array.from(prefillVals));
        }
      }
      this.loading.validations = false;
    },
  },
  mounted() {},
};
</script>

<style lang="scss" scoped></style>
